import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { verify } from '../Utils/Authentication'

function PrivateRoute(props) {
    const destination = props.to
    const children = props.children
    const [ loaded, setLoadded ] = useState( false )
    const [ hasAccess, setHasAccess ] = useState( false )

    useEffect( () => {
        verify().then( auth => {
            if( auth )
            {
                setHasAccess( true )
            }
            else
            {
                setHasAccess( false )
            }

            setLoadded( true )
        })

    },[])

    if( !loaded )
    {
        return ( <></> )
    }

    return hasAccess ? children : <Navigate to={ destination } />;
}

export default PrivateRoute;
